import { permissionsRol as licensesBatchRol } from 'app/policies/roles/licensesBatchRol.access';
import { PATH_LICENSE_BATCH, PATH_LICENSE_BATCHS, PATH_LICENSE_BATCH_CREATE } from 'app/router/routesConfigLicensesBatch';

export function licensesBatch(path, user) {
  if (PATH_LICENSE_BATCH === path) {
    return licensesBatchRol(user).readDetail;
  }

  if (PATH_LICENSE_BATCHS === path) {
    return licensesBatchRol(user).readList;
  }

  if (PATH_LICENSE_BATCH_CREATE === path) {
    return licensesBatchRol(user).create;
  }

  return true;
}
